import { Entity, resource } from 'aurelia-orm';

@resource('support-ticket')
export class SupportTicket extends Entity {
	id: number;
	name = null;
	details: string;
	itemStatusId: number;
}